var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 102,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.599 8.6a8.727 8.727 0 1 1 0 17.453h-49.866a8.727 8.727 0 0 1 8.726 8.727 8.727 8.727 0 0 1-8.726 8.727h27.426a8.727 8.727 0 1 1 0 17.453h-12.683c-6.077 0-11.003 3.907-11.003 8.727 0 3.213 2.493 6.122 7.48 8.726a8.727 8.727 0 0 1 8.726 8.727 8.727 8.727 0 0 1-8.726 8.727H57.479a8.727 8.727 0 0 1 0-17.454H8.86a8.727 8.727 0 1 1 0-17.453h49.867a8.727 8.727 0 0 0 0-17.453H27.56a8.727 8.727 0 0 1 0-17.454h49.866a8.727 8.727 0 1 1 0-17.453H199.6Zm0 34.907a8.727 8.727 0 1 1 0 17.453 8.727 8.727 0 0 1 0-17.453Z",
    fill: "#85B440",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.836 102c28.166 0 51-22.834 51-51s-22.834-51-51-51c-28.167 0-51 22.834-51 51s22.833 51 51 51Zm-6.11-47.03 23.783-23.095 7.827 7.415-31.61 30.518-18.967-17.426 7.823-7.418L97.726 54.97Z",
    fill: "#E3EDD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.67 54.776 124.052 28.9l8.682 8.308L97.67 71.4 76.633 51.877l8.677-8.312 12.36 11.21Z",
    fill: "#85B440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingCompleted);
export default __webpack_public_path__ + "static/media/onboarding_completed.0afbfbd6b69c3a4b90369aaac9212932.svg";
export { ForwardRef as ReactComponent };